import { Styles } from './types';

export const styles: Styles = {
    control: () => ({ display: 'none' }),
};
